export default "/images/2deab522a21f4a1b52966aa1274b3503.avif";